export function shouldShowApplyNow(pathname) {
  if (typeof pathname !== "string") return false
  const path = pathname.replace(/\/+$/, "")
  return pathname === "/" || path === "/certification/procedure"
}
